const navigation = () => {

    const CLASSES = {
        'slider': 'roadmap-timeline__container',
        'buttonLeft': 'roadmap-timeline__controls__control--left',
        'buttonRight': 'roadmap-timeline__controls__control--right',
        'active': 'active'
    }

    const slider = document?.querySelector('.' + CLASSES.slider);
    const buttonLeft = document?.querySelector('.' + CLASSES.buttonLeft);
    const buttonRight = document?.querySelector('.' + CLASSES.buttonRight);

    const contentScrollWidth = slider?.scrollWidth;
    let contentScollLeft = slider?.scrollLeft;

    if (buttonRight != null && buttonLeft != null) {
        buttonRight.addEventListener('click', () => {
            contentScollLeft += 400;
            if (contentScollLeft >= contentScrollWidth) {
                contentScollLeft = contentScrollWidth;
            } else if (!buttonLeft.classList.contains(CLASSES.active)) {
                buttonLeft.classList.add(CLASSES.active);
            }
            slider.scrollLeft = contentScollLeft;
        });
        buttonLeft.addEventListener('click', () => {
            contentScollLeft -= 400;
            if (contentScollLeft <= 0) {
                contentScollLeft = 0;
                buttonLeft.classList.remove(CLASSES.active);
            }
            slider.scrollLeft = contentScollLeft;
        });
    }

}

export default navigation;